import React from "react";
import styles from "./index.module.css";
import Image from "next/image";
import { imageScale } from "@/utils/motion";
import { useInView } from "react-intersection-observer";
import { AnimatePresence, motion } from "framer-motion";

import { GilroyFontDark, GilroyFontLight } from "@lib/GilroyFont";
import Link from "next/link";

const Section01 = ({ data }) => {
  const [ref, inView] = useInView({
    triggerOnce: true, // This means the animation will trigger only once when it comes into view
    threshold: 0.1, // Percentage of the component's visibility, adjust as needed
  });

  const animation = inView ? imageScale(1.5).animate : imageScale(0.5).initial;

  return (
    <div ref={ref} className="pb-[2rem] min-h-screen">
      <AnimatePresence>
        <motion.div initial={imageScale(0.5).initial} animate={animation}>
          <div className="flex flex-col items-start pt-[4rem] px-[0.5rem] sm:px-[2.5rem] max-w-[90rem] m-auto">
            <div className="sm:flex items-start text-black ">
              <div className={` ${GilroyFontLight.className}  min-w-[50%] `}>
                <div className="min-w-[100%] ">
                  {/* <h2 className={` ${styles.heading_about_us} ${GilroyFontDark.className} `} >About us</h2> */}
                  <h1
                    className={` text-[36px] sm:text-[65px] text-black  ${GilroyFontDark.className} `}
                  >
                    {" "}
                    {data?.a1_first_heading}{" "}
                  </h1>
                </div>

                <p className={styles.paragraph_styles}>
                  {data?.a1_first_paragraph}{" "}
                </p>
                <p className={styles.paragraph_styles}>
                  {data?.a1_second_paragraph}
                </p>
                <p className={styles.paragraph_styles}>
                  {data?.a1_third_paragraph}
                </p>
                <p className='font-bold text-[15px] text-black italic mt-4'>Highly Recommended & Trusted By</p>
    <div className='flex gap-3 sm:gap-8 justify-start '>
    <Link href={`https://www.google.com/search?gs_ssp=eJzj4tVP1zc0LEsyqEw3T8s2YLRSMahINLU0NEyxMEkyT0oxNjUxtDKoMDdKszQ1szA1NzdJMTA39-IpSU3OSE7NSS1KzCsBAHJXE0E&q=techcelerant&oq=techcele&gs_lcrp=EgZjaHJvbWUqDQgCEC4YrwEYxwEYgAQyBggAEEUYPDIGCAEQRRg8Mg0IAhAuGK8BGMcBGIAEMgYIAxBFGDkyBwgEEAAYgAQyBwgFEAAYgAQyBggGEEUYPDIGCAcQRRg80gEINDk4MmowajGoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0xa5911d84b7bd3541:0x72f95685774d077,1,,,,`} target='_blank'>
    <Image
                        height={100}
                        width={140}
                        className="w-[110px] h-[60px] mt-2"
                        alt="facebook icon"
                        src="/rev1.png"
                      />
                      </Link>
                      <Link href={`https://www.trustpilot.com/review/techcelerant.com`} target="_blank">
                      <Image
                        height={100}
                        width={140}
                        className="w-[110px] h-[60px] mt-2"
                        alt="facebook icon"
                        src="/rev2.png"
                      />
                      </Link>

    </div>
              </div>
  
            </div>
            <Image
              className="pt-[2rem] min-w-[100%]"
              alt={data?.a1_first_image_alt}
              responsive
              width={1000}
              height={1000}
              src={data?.a1_first_image}
            />
            {/* <VideoSlider /> */}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Section01;
